import _                                    from 'underscore';
import classNames                           from 'classnames';
import React, { FC, useContext, useEffect } from 'react';
import { Icon, Popup }                      from 'semantic-ui-react';

import { UIDisplayModesHashType, useUIDisplayModes } from '../../../hooks';
import { UI_DISPLAY_MODES }                          from '../../../constants/UIEnums';
import { Position }                                  from '../../../types';
import { StyledContainer }                           from '../../containers';
import { DynamicComponentsContext }                  from '../../contexts';

export interface Props {
	toggleModes: UI_DISPLAY_MODES[]
}

const defaultProps: Props = {
	toggleModes: [],
};

const DisplayModeControl: FC<Props> = ( props ) => {
	
	let { sidebar: [ sidebarState ] }                  = useContext( DynamicComponentsContext ),
	    { isModeActive, toggleModes, minimizedChrome } = useUIDisplayModes();
	
	let toggleSet      = _.object( props.toggleModes, _.range( props.toggleModes.length ).map( m => !minimizedChrome ) ) as UIDisplayModesHashType,
	    toggleSetState = _.mapObject( _.clone( toggleSet ), ( value, mode ) => isModeActive( mode as UI_DISPLAY_MODES ) );
	
	useEffect( () => {}, [ sidebarState ] )
	
	// initialize any modes not in line with minimizeChrome
	useEffect( () => {
		
		let syncedState = _.chain( toggleSetState )
		                   .omit( UI_DISPLAY_MODES.CHROME_MINIMIZED )
		                   .mapObject( () => minimizedChrome )
		                   .value() as UIDisplayModesHashType;
		
		toggleModes( syncedState );
		
	}, [] )
	
	const handleToggle = ( e ) => {
		
		toggleModes( toggleSet );
	}
	
	if( sidebarState.isOpen ) return null;
	
	return (
		
		<Popup
			size={ 'tiny' }
			position={ 'left center' }
			content={ minimizedChrome ? 'Show all page areas' : 'Maximize page view' }
			trigger={ (
				
				<StyledContainer
					position={ Position.FIXED }
					top={ 0 }
					right={ 0 }
					zIndex={ 1000 }
					className={ classNames( 'fade-in animation-delay-ms-1000 cursor--pointer' ) }
					style={ {
						opacity:        0,
						transition:     'all 1000 ease-in-out',
						display:        'flex',
						justifyContent: 'center',
						alignItems:     'center',
						
						width:  94,
						height: 40,
						
						transform:  `rotate(45deg) translateY(-30px) translateX(20px)`,
						background: `rgba(0, 0, 0, ${ minimizedChrome ? '0.05' : '0.5' })`,
					} }
					onClick={ handleToggle }>
					
					<StyledContainer position={ Position.ABSOLUTE }
					                 style={ { transform: `rotate(45deg)` } }
					                 className={
						                 classNames(
							                 'text-left text--xs cursor--pointer fade-in animation-delay-ms-1000',
							                 { 'opacity--80': minimizedChrome }
						                 ) }>
						
						{ minimizedChrome
						  ? <Icon size={ 'large' } name={ 'compress' } inverted fitted/>
						  : <Icon size={ 'large' } name={ 'expand' } inverted fitted/>
						}
					
					</StyledContainer>
				
				</StyledContainer>
			) }/>
	)
};

DisplayModeControl.defaultProps = defaultProps;

export { DisplayModeControl }
